import React from "react";

var FilterIcon = function FilterIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 16 : _ref$height;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 9.65625V10V12.0625L9 13.8125V10V9.65625L9.21875 9.375L15 2.65625V2H1V2.65625L6.75 9.375L7 9.65625ZM0 3V2V1H1H15H16V2V3L10 10V14.6875V16L9 15.125L6 12.5V10L0 3Z",
    fill: "#212223"
  }));
};

export default FilterIcon;